import React from "react";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import BookDescriptionManual from "../book-description-manual/bookDescriptionManual";
import HeadboardBookDetail from "../headboard-book-detail/headboardBookDetail";

import "./bookDetailManual.scss";

interface BookDetailManualInter {
  cabecera?: ReferenciaCabecera;
  library?: ReferenciaContenido;
}

const BookDetailManual = (props: BookDetailManualInter) => {
  let { cabecera, library } = props;

  let description =
    library?.referenciaTabsContenido[0].referenciaCursosDestacados[0]
      .descripcion.json.content[0].content[0].value;
  let tabs = library?.referenciaTabsContenido[0].referenciaCursosDestacados[0].listaTags.map(
    (elem) => {
      return { descripcion: elem };
    }
  );
  let descriptionEvent =
    library?.referenciaTabsContenido[0].referenciaCursosDestacados[0]
      .descripcionEvento.json;

  let nameAuthor = undefined;
  if (typeof cabecera !== "undefined") {
    nameAuthor = cabecera[0].descripcion.json.content[0].content[0].value;
  }

  return (
    <div className="o-book-detail-manual">
      {typeof cabecera !== "undefined" && (
        <Breadcrumb content={cabecera[0].migaDePan} />
      )}
      {typeof cabecera !== "undefined" && (
        <HeadboardBookDetail
          author={nameAuthor || ""}
          image={cabecera[0].imagenHeader.file.url || ""}
          title={cabecera[0].tituloPrincipal || ""}
          fragment={cabecera[0].redireccionBoton || ""}
          courceContent={cabecera[0].tipoLibro || "physical"}
          isAudiobook={cabecera[0].tipoLibro === "audiobook"}
          mmsId=""
        />
      )}
      {typeof library !== "undefined" && (
        <BookDescriptionManual
          description={description}
          subjectsList={tabs || ""}
          descriptionEvent={descriptionEvent}
        />
      )}
    </div>
  );
};

export default BookDetailManual;
